import type {StateCreator} from 'zustand'
import type {IssueComment} from '../../page-data/payloads/issue-comments'

export type IssueCommentSlice = {
  issueComments: IssueComment[]

  commentsPanelActions: {
    setIssueComments: (comments: IssueComment[]) => void
    addIssueComment: (comment: IssueComment) => void
    addIssueComments: (comments: IssueComment[]) => void
    updateIssueComment: (args: {
      match: (comment: IssueComment) => boolean
      transform: (comment: IssueComment | undefined) => IssueComment | undefined
    }) => void
  }
}

export const createIssueCommentSlice =
  (): StateCreator<IssueCommentSlice, [['zustand/devtools', never]], [], IssueCommentSlice> => (set, _get) => ({
    issueComments: [],

    commentsPanelActions: {
      setIssueComments: comments => {
        set({issueComments: comments}, undefined, 'setIssueComments')
      },
      addIssueComments: comments => {
        set(
          state => {
            return {
              issueComments: [...state.issueComments, ...comments],
            }
          },
          undefined,
          'addIssueComments',
        )
      },
      addIssueComment: comment => {
        set(
          state => {
            return {
              issueComments: [...state.issueComments, comment],
            }
          },
          undefined,
          'addIssueComment',
        )
      },

      updateIssueComment: ({match, transform}) => {
        set(
          state => ({
            issueComments: state.issueComments.map(comment => {
              if (match(comment)) {
                const updated = transform(comment)
                return updated ?? comment
              }
              return comment
            }),
          }),
          undefined,
          'updateIssueComment',
        )
      },
    },
  })
